import { isIndex } from './objectCore';

export function keys(object: unknown): string[] {
    if (object == null) {
        return [];
    }
    const source = Object(object);
    const tag = Object.prototype.toString.call(source);
    const indexed =
        Array.isArray(source) ||
        tag === '[object Arguments]' ||
        (ArrayBuffer.isView(source) && tag !== '[object DataView]');
    if (indexed) {
        const result = Array.from({ length: source.length }, (_value, index) => String(index));
        const typed = ArrayBuffer.isView(source);
        for (const key of Object.keys(source)) {
            if (
                key !== 'length' &&
                !isIndex(key, source.length) &&
                !(typed && ['buffer', 'byteLength', 'byteOffset', 'offset', 'parent'].includes(key))
            ) {
                result.push(key);
            }
        }
        return result;
    }
    const result = Object.keys(source);
    return source === source.constructor?.prototype
        ? result.filter(key => key !== 'constructor')
        : result;
}
